/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RefundPrepaidByPSPTransaction
 */
export interface RefundPrepaidByPSPTransaction {
    /**
     * 
     * @type {string}
     * @memberof RefundPrepaidByPSPTransaction
     */
    parentTransactionId?: string;
}

/**
 * Check if a given object implements the RefundPrepaidByPSPTransaction interface.
 */
export function instanceOfRefundPrepaidByPSPTransaction(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function RefundPrepaidByPSPTransactionFromJSON(json: any): RefundPrepaidByPSPTransaction {
    return RefundPrepaidByPSPTransactionFromJSONTyped(json, false);
}

export function RefundPrepaidByPSPTransactionFromJSONTyped(json: any, ignoreDiscriminator: boolean): RefundPrepaidByPSPTransaction {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'parentTransactionId': !exists(json, 'parentTransactionId') ? undefined : json['parentTransactionId'],
    };
}

export function RefundPrepaidByPSPTransactionToJSON(value?: RefundPrepaidByPSPTransaction | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'parentTransactionId': value.parentTransactionId,
    };
}

